const LastnikiNepremicnin = () => {
  return <div>LastnikiNepremicnin</div>;
};

export default LastnikiNepremicnin;
